import React, { useEffect, useState } from "react";
import MatchDetailHead from "../../common/MatchDetailHead";
import MatchDetailTabs from "../../common/MatchDetailTabs";
import { linkName, processMyArr } from "../../../utils/generalLiveCenter";

const Head = ({
  matchDetail,
  difference,
  sport,
  setDataId,
  setDataType,
  setHead,
  setLeagueId,
  dataClient,
  children,
  id,
  currentTab,
  websiteBaseUrl,
  dataPath,
  title,
  socketUrl,
  channel,
  event,
}) => {
  const [clientHeadData, setClientHeadData] = useState(null);

  useEffect(() => {
    if (!dataClient) return;

    const container = document.querySelector(".microservice-cont");
    const dataAttr = container?.getAttribute("data-listingdata");

    if (dataAttr) {
      try {
        const parsed = JSON.parse(dataAttr)?.headData;
        setClientHeadData(parsed);
      } catch (error) {
        console.error("Failed to parse headData:", error);
      }
    }
  }, [dataClient]);

  const matchData = dataClient ? clientHeadData?.data : matchDetail?.data;
  const tabsData = dataClient ? clientHeadData?.newtabs || clientHeadData?.tabs : matchDetail?.newtabs;

  const referee = matchData?.match_official?.official?.name;
  const venue = matchData?.venue;
  const form = dataClient ? clientHeadData?.lfm : matchDetail?.lfm;

  return (
    <div className="detail_page">
      {title && <h1>{title}</h1>}

      <div className="detail_head">
        <MatchDetailHead
          sport={sport}
          data={matchData}
          difference={difference}
          referee={referee}
          venue={venue}
          setDataId={setDataId}
          setDataType={setDataType}
          setHead={setHead}
          setLeagueId={setLeagueId}
          websiteBaseUrl={websiteBaseUrl}
          dataPath={dataPath}
          dataClient={dataClient}
          form={sport === "tennis" && form}
          socketUrl={socketUrl}
          channel={channel}
          event={event}
        />

        {dataClient && (
          <MatchDetailTabs
            tabs={processMyArr(tabsData) || []}
            id={id}
            currentTab={currentTab}
            websiteBaseUrl={websiteBaseUrl}
            dataPath={dataPath}
            name={`${linkName(matchData?.competitors?.htn)}-vs-${linkName(
              matchData?.competitors?.atn
            )}`}
            sport={sport}
          />
        )}
      </div>

      <div className="detail_page_tabs">{children}</div>
    </div>
  );
};

export default Head;
